// Subscription selector block: toggle one-time/subscribe, swap each option's per-treatment text,
// and keep the CTA price + href in sync with the checked option. Navigation is the native <a> href.
if (!window.customElements.get('subscription-selector')) {
  window.customElements.define(
    'subscription-selector',
    class SubscriptionSelector extends window.HTMLElement {
      connectedCallback() {
        this.oneTimeBtn = this.querySelector('[data-toggle="one-time"]');
        this.subscribeBtn = this.querySelector('[data-toggle="subscribe"]');
        this.options = [...this.querySelectorAll('[data-option]')];
        this.radios = [...this.querySelectorAll('input[type="radio"]')];
        this.freqValue = this.querySelector('[data-frequency-value]');
        this.cta = this.querySelector('[data-cta]');
        this.ctaTotal = this.querySelector('[data-cta-total]');
        this.ctaCompare = this.querySelector('[data-cta-compare]');
        this.isOneTime = false;

        this.oneTimeBtn?.addEventListener('click', () => this.setMode(true));
        this.subscribeBtn?.addEventListener('click', () => this.setMode(false));
        this.radios.forEach((radio) => radio.addEventListener('change', () => this.render()));

        this.render();
      }

      setMode(isOneTime) {
        this.isOneTime = isOneTime;
        this.oneTimeBtn?.classList.toggle('is-active', isOneTime);
        this.subscribeBtn?.classList.toggle('is-active', !isOneTime);
        this.classList.toggle('is-one-time', isOneTime);
        this.render();
      }

      render() {
        const p = this.isOneTime ? 'one' : 'sub';

        this.options.forEach((option) => {
          const data = option.querySelector('input[type="radio"]').dataset;
          this.setText(option.querySelector('[data-per]'), data[`${p}Per`]);
          this.setText(option.querySelector('[data-compare]'), data[`${p}Compare`]);
          this.setText(option.querySelector('[data-savings]'), data[`${p}Savings`]);
        });

        const checked = this.radios.find((radio) => radio.checked) || this.radios[0];
        if (!checked) return;
        const data = checked.dataset;

        if (this.freqValue) this.freqValue.textContent = data.frequency || '';
        this.setText(this.ctaTotal, data[`${p}Total`]);
        this.setText(this.ctaCompare, data[`${p}CompareTotal`]);
        if (this.cta) this.cta.href = data[`${p}Url`] || '#';
      }

      setText(el, value) {
        if (!el) return;
        el.textContent = value || '';
        el.classList.toggle('is-hidden', !value);
      }
    },
  );
}
